import { ReactFlowProvider } from "reactflow";
import MacroNode from "./macroNode";
import { MacroNodeProps } from "./macroNode.types";

export type { MacroNodeProps };

const MacroNodeProvider = (props: MacroNodeProps) => {
    return (
        <ReactFlowProvider>
            <MacroNode {...props} />
        </ReactFlowProvider>
    );
};

export default MacroNodeProvider;
